import { computed, defineComponent } from "vue";
import Loading from "./loading";
import Popup from "./popup";

import "./toast.less";

export default defineComponent({
  emits: ["update:visible"],
  props: {
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    message: { type: String, default: "" },
  },
  setup(props, { slots, emit }) {
    const show = computed({
      get: () => props.visible,
      set: (value: boolean) => {
        emit("update:visible", value);
      },
    });

    const renderContentNode = () => {
      if (slots.default) return slots.default();
      if (props.loading) return <Loading />;
      return props.message;
    };

    return () => (
      <Popup
        maxWidth="88%"
        overlay={props.loading}
        overlayClass="feiyu-web-share-toast--overlay"
        position="center"
        v-model:visible={show.value}
      >
        <div class={["feiyu-web-share-toast", { "feiyu-web-share-toast--loading": props.loading }]}>
          <div class="feiyu-web-share-toast--content">{renderContentNode()}</div>
        </div>
      </Popup>
    );
  },
});
